import { render } from "./EasyConfig.vue?vue&type=template&id=579673d1&scoped=true"
import script from "./EasyConfig.vue?vue&type=script&lang=js"
export * from "./EasyConfig.vue?vue&type=script&lang=js"

import "./EasyConfig.vue?vue&type=style&index=0&id=579673d1&scoped=true&lang=css"

import exportComponent from "/home/james/WebstormProjects/pvpconfigui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-579673d1"]])

export default __exports__